/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.CreateNote";
        class DocActionCreateNote extends DocActions.DocActionBaseClass {
            constructor(core, name) {
                super(core, name);
                this._notesComponent = null;
                this._noteCreated = () => {
                    this._log.info("DocActionCreateNote._noteCreated()");
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionCreateNote::constructor");
                this._label = this._core.Locale.getTranslation("STR_WPT_CREATE_NOTE");
                let componentConf = { SuppressDisplay: true };
                this._notesComponent = new WPTNamespace.Widgets.ComponentNotes(core, null, null, componentConf);
                this._notesComponent.present();
            }
            actionAllowed(request) {
                this._log.info("DocActionCreateNote.actionAllowed()");
                let notePrivilege = true;
                if (request.hasOwnProperty('DocumentType') && request.DocumentType) {
                    if (request.DocumentType.Name in this._core.OBHelper.DownloadDocumentTypeMap) {
                        let docType = this._core.OBHelper.DownloadDocumentTypeMap[request.DocumentType.Name];
                        notePrivilege = docType.Privileges.CreateNote;
                    }
                }
                return notePrivilege;
            }
            execute(request) {
                this._log.info("DocActionCreateNote.execute()");
                this._notesComponent.createNoteInteractive(request.DocHandle, this._noteCreated);
            }
        }
        DocActions.DocActionCreateNote = DocActionCreateNote;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
